<template>
  <tr>
    <td v-if="isEditing">
      <input type="text" name="" v-model="hubData.name" class="form-control hub-input">
      <universal-multiselect label="name"
                             fieldLabel="name"
                             fieldTrackBy="id"
                             :initialValues="hubData.services"
                             :availableValues="servicesOptions"
                             :placeholder="$t('multiselect.placeholder')"
                             validationName="available_services"
                             validationRules="required"
                             :closeOnSelect="false"
                             :displayLabel="false"
                             @change="onChange($event)" />

      <div class="pull-right">
        <a href="#" class="text-primary" @click="updateHub">{{ $t('buttons.save') }}</a>
        <span class="m-l-5 m-r-5">|</span>
        <a href="#" class="text-danger" @click="cancelUpdateHub">{{ $t('actions.cancel') }}</a>
      </div>
    </td>

    <td class="v-align-middle" v-else>
      <div class='hub-label'> {{ hub.name }} </div>
      <div> {{ servicesNames }} </div>
    </td>

    <td class="p-t-5 p-b-5 v-align-middle">
      <div class="btn-toolbar flex-wrap">
        <div v-if="!hub.is_fake" class="btn-group">
          <a href="#" class="btn btn-icon" @click.prevent="editHub">
            <i class="fa fa-edit"></i>
          </a>
          <a href="#" class="btn btn-icon-dark" @click.prevent="deleteHub">
            <i class="fa fa-trash-o"></i>
          </a>
        </div>
      </div>
    </td>
  </tr>
</template>

<script type="text/javascript">
  import { mapActions, mapGetters } from 'vuex'
  import UniversalMultiselect from '@/components/form/UniversalMultiselect'
  import ie_mixin from '@/mixin/ie'

  export default {
    name: 'HubRow',
    props: ['hub', 'entityId'],
    mixins: [ie_mixin],
    components: {
      UniversalMultiselect
    },
    data() {
      return {
        isEditing: false,
        hubData: {}
      }
    },
    methods: {
      ...mapActions({
        update: 'hubs/update',
        delete: 'hubs/delete',
        loadList: 'hubs/loadList',
        loadAvailableServicesForHub: 'hubs/loadAvailableServicesForHub'
      }),
      editHub() {
        this.isEditing = true;
        this.loadAvailableServicesForHub(this.hub.id);
        this.hubData = {...this.hub};
      },
      updateHub() {
        this.update(this.hubData)
        .then((result) => {
          if(result) this.isEditing = false;
          this.isEditing = false;
          this.loadList(this.entityId)
        })
      },
      cancelUpdateHub() {
        this.isEditing = false;
        this.hubData = {...this.hub};
      },
      deleteHub() {
        this.$dialog.confirm(this.deleteMessage, { html: true })
          .then(() => {
            this.delete(this.hub).then(() => {
              this.loadList(this.entityId)
            })
          })
          .catch(function() {})
      },
      onChange(values) {
        this.hubData.services = values
      }
    },
    computed: {
      ...mapGetters({
        servicesOptions: 'hubs/availableServices'
      }),
      servicesNames() {
        return this.hub.services.map(service => service.name).sort().join(', ')
      },
      deleteMessage() {
        const resource = this.$i18n.t('resources.hub');
        const hubName = this.hub.name;
        return `${this.$t('messages.delete_confirmation', {'resource': resource, 'name': hubName})}<br>
                ${this.$t('messages.hubs_delete_to_note')}`
      }
    },
    watch: {
      servicesSelectedIE: function (values) {
        if (this.servicesOptions.length > 0) {
          var selected = []
          values.map(item => selected.push(this.searchInArray(item, this.servicesOptions)))
          this.hub.services = selected
        }
      }
    },
    mounted: async function() {
      this.hubData = {...this.hub};
      if(this.isIE) {
        this.servicesSelectedIE = [];
        this.servicesSelectedIE = this.hub.services.map(item => item['name'])
      }
    }
  }
</script>

<style lang="scss" scoped>
  .hub-input {
    margin-bottom: 20px;
  }
  .hub-label {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/hubs/HubRow.vue